import axios from "axios";
import qs from "qs";
import { getFingerprint } from "~/helpers/fingerprinting";

export default (itemsPerPage = 10) => {
	const client = axios.create({
		baseURL: "https://api.bazaarvoice.com/data",
	});

	client.interceptors.response.use((res) => res.data);

	const KEY = "p14o9fanys23wctzqx92gnlrf";

	const getReviews = (productId, page = 0) =>
		client.get(
			`/reviews.json?apiversion=5.4&passkey=${KEY}&Filter=ProductId:${productId}&Include=Products&Stats=Reviews&Limit=${itemsPerPage}&Offset=${
				page * itemsPerPage
			}`,
		);

	const postReview = async (productId, review) => {
		const fp = await getFingerprint();

		return client({
			method: "POST",
			headers: {
				"content-type": "application/x-www-form-urlencoded",
			},
			data: qs.stringify({ ...review, fp, Action: "Submit", passkey: KEY, ProductId: productId, ApiVersion: "5.4" }),
			url: "/submitreview.json",
		});
	};

	return {
		getReviews,
		postReview,
	};
};
